import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/axios.js";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email || ""; // البريد المرسل من صفحة التسجيل

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!otp) {
      setError("يرجى إدخال رمز التحقق");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await api.post("/verify-otp", {
        email,
        otp,
      });

      // حفظ التوكن في localStorage
      localStorage.setItem("access_token", response.data.access_token);

      // إعادة التوجيه للـ Dashboard
      navigate("/dashboard");
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || "فشل التحقق");
      } else {
        setError("خطأ في الاتصال بالخادم");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>تحقق من رمز OTP</h2>
        <p>تم إرسال رمز التحقق إلى البريد: <b>{email}</b></p>

        <input
          type="text"
          placeholder="أدخل رمز التحقق"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          style={styles.input}
        />

        {error && <p style={styles.error}>{error}</p>}

        <button onClick={handleVerify} style={styles.button} disabled={loading}>
          {loading ? "جاري التحقق..." : "تحقق"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#e8eee7ff",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Cairo', sans-serif",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  title: {
    marginBottom: "1rem",
    color: "#1e293b",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  button: {
    backgroundColor: "#81df43ff",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontSize: "1rem",
  },
  error: {
    color: "red",
    marginBottom: "10px",
    fontSize: "0.9rem",
  },
};
